export interface IPredefinedReel {
  id: string;
  value: number[][][];
  isLocal?: boolean;
}

export enum CheatType {
  Config = 'Custom Config',
  Command = 'Command',
  Reels = 'Reels set',
}

export interface ActiveCheat<T = any> {
  type: CheatType;
  once?: boolean;
  value: T;
}
